const APP_NAME = "ALMA-TUNNUS";

export default (config) => {
  const basicLogging =
    false ||
    typeof window === "undefined" ||
    (typeof document !== "undefined" && !!document.documentMode) ||
    window.navigator.userAgent.indexOf("Edge") > -1;

  const logObj = (obj) => JSON.parse(JSON.stringify(obj));
  const logColors = {
    success: "green",
    info: "blue",
    error: "red",
    warning: "orange",
  };
  const logGAColor = () => "background: blue; color: white; padding: 4px";

  const log = (message, object, color = "") => {
    try {
      const content = object !== undefined ? logObj(object) : "";
      if (basicLogging) console.log(`[${APP_NAME}] ${message}`, content);
      else console.log(`%c[${APP_NAME}] %c${message}`, `color: #a04191`, `color:${logColors[color] || ""}`, content);
    } catch (err) {
      console.error("logging failed: ", err);
    }
  };
  const logTitle = (message) => log(message, "", "#8F8B10");
  const logGATitle = (message) => (basicLogging ? console.log(message) : console.log(`%c${message}`, logGAColor()));

  return config.debugMode
    ? {
        log,
        logTitle,
        logGATitle,
      }
    : {
        log: () => {},
        logTitle: () => {},
        logGATitle: () => {},
      };
};
